module.exports = __webpack_public_path__ + "img/corsica.065b5ede.svg";